import type { BrowserAnalytics } from "@hereby/components/analytics";
import { INQUIRY_FALLBACK_ERROR, postInquiry } from "./inquiry";
export function createInquiryForm(
  ApiBaseUrl: string,
  landingAnalytics: Pick<BrowserAnalytics, "event">,
  sendInquiry = postInquiry,
) {
  return {
    size: "",
    email: "",
    /** 페인포인트 — 어떤 고민으로 찾아왔는지가 영업·제품 판단의 참고 자료가 된다. */
    pain: "",
    /** 봇 함정 — 사람에게는 보이지 않는 칸이라 값이 차 있으면 서버가 조용히 버린다 */
    website: "",

    sending: false,
    sent: false,
    error: "",

    async submit(): Promise<void> {
      if (this.sending || this.sent) {
        return;
      }
      this.error = "";

      // 클라이언트 검증은 되돌아오는 왕복을 아끼는 용도다 — 실제 방어선은 서버 스키마다
      if (!this.size) {
        this.error = "병원 규모를 선택해 주세요.";
        return;
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
        this.error = "연락받으실 메일 주소를 정확히 입력해 주세요.";
        return;
      }
      if (!this.pain) {
        this.error = "개선하고 싶은 업무를 선택해 주세요.";
        return;
      }

      landingAnalytics.event("cta_click", "inquiry_submit");
      this.sending = true;
      try {
        await sendInquiry(ApiBaseUrl, {
          size: this.size,
          email: this.email,
          pain: this.pain,
          website: this.website,
        });
        this.sent = true;
        if (!this.website) {
          landingAnalytics.event("generate_lead", "inquiry_accepted");
        }
      } catch (e) {
        this.error = e instanceof Error ? e.message : INQUIRY_FALLBACK_ERROR;
      } finally {
        this.sending = false;
      }
    },
  };
}
